/** Plain objects created from JSON.parse / DTOs (not Date, Map, etc.). */
function isPlainRecord(v: unknown): v is Record<string, unknown> {
    return v !== null && typeof v === "object" && Object.getPrototypeOf(v) === Object.prototype;
}

/**
 * Recursively removes keys whose value is null or undefined so API/JSON payloads and previews
 * do not contain sparse null-filled trees (common with Jackson / OpenAPI clients).
 */
export function stripNullsDeep<T>(value: T): T {
    if (value === null || value === undefined) {
        return value as T;
    }
    if (Array.isArray(value)) {
        const next = (value as unknown[])
            .map((item) => stripNullsDeep(item))
            .filter((item) => item !== null && item !== undefined);
        return next as T;
    }
    if (isPlainRecord(value)) {
        const out: Record<string, unknown> = {};
        for (const [k, v] of Object.entries(value)) {
            if (v === null || v === undefined) {
                continue;
            }
            const inner = stripNullsDeep(v);
            if (inner === null || inner === undefined) {
                continue;
            }
            if (isPlainRecord(inner) && Object.keys(inner).length === 0) {
                continue;
            }
            if (Array.isArray(inner) && inner.length === 0) {
                out[k] = inner;
                continue;
            }
            out[k] = inner;
        }
        return out as T;
    }
    return value;
}
